import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=4f716870&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=js&"
export * from "./TaskCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=4f716870&lang=scss&scoped=true&"
import style1 from "./TaskCard.vue?vue&type=style&index=1&id=4f716870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f716870",
  null
  
)

export default component.exports